<div class="loading-container" fxLayout="row" fxLayoutAlign="center center" >
    <mat-spinner diameter="35" class="loading-spinner "></mat-spinner>
    <h2 >Παρακαλώ περιμένετε</h2>
</div>